import { TimeFrameModel } from '../models/absence-planer/time-frame.model';

export class AbsencePlanerTimeframeEnum {
  static month = {
    value: 0,
    name: 'resourceTime1Month',
  } as TimeFrameModel;

  static threeMonths = {
    value: 1,
    name: 'resourceTime3Month',
  } as TimeFrameModel;

  static sixMonths = {
    value: 2,
    name: 'resourceTime6Month',
  } as TimeFrameModel;

  static nineMonths = {
    value: 3,
    name: 'resourceTime9Month',
  } as TimeFrameModel;

  static year = {
    value: 4,
    name: 'resourceTimelineYear',
  } as TimeFrameModel;
}
